'use strict';

exports.__esModule = true;
exports.default = getParsed;

var _postcssValueParser = require('postcss-value-parser');

var _postcssValueParser2 = _interopRequireDefault(_postcssValueParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getParsed(decl) {
    var value = decl.value,
        raws = decl.raws;

    if (raws && raws.value && raws.value.raw) {
        value = raws.value.raw;
    }
    return (0, _postcssValueParser2.default)(value);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/postcss-ordered-values/dist/lib/getParsed.js
// module id = 3466
// module chunks = 0